var React = require('react');

function Undo (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.3,3c1.5,0,3,0.6,4.2,1.7c2.3,2.3,2.3,6,0,8.2c-0.9,0.9-2.1,1.5-3.4,1.7c-0.3,0-0.5,0-0.8,0H1.9","key":0}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.2,3.4 8.2,5.4 8.2,3.4 8.2,1.4 \t","key":1})]));
}

Undo.displayName = "Undo";

Undo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Undo;

Undo.default = Undo;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/undo.svg
// module id = ../icon/src/icons/undo.svg
// module chunks = 0